import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useEffect } from "react";

import About from "./components/About";
import AboutIGI from "./pages/AboutIGI";
import Agenda from "./pages/Agenda";
import Banner from "./components/Banner";
import Footer from "./components/Footer";
import Header from "./components/Header";
import JoiningUs from "./components/JoiningUs";
import NetworkingTimeline from "./components/NetworkingTimeline";
import Participation from "./components/Participation";
import Partners from "./pages/Partners";
import Speakers from "./pages/Speakers";
import SpeakerDetails from "./pages/SpeakerDetails";
import WhoWeAre from "./pages/WhoWeAre";
import LatestNews from "./pages/LatestNews";
import LatestNewsDetails from "./pages/LatestNewsDetails";
import ErrorBoundary from "./components/ErrorBoundary";
import Publications from "./pages/Publications";
import PublicationDetails from "./pages/PublicationDetails";
import RegistrationForm from "./components/RegisterForm";

import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top on route change
  }, [location]);

  return null;
};

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <ScrollToTop />
        <Header />
        <main className="min-h-screen w-full overflow-x-hidden ">
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Banner />
                  <About />
                  <WhoWeAre />
                  <Agenda />
                  <Speakers />
                  <JoiningUs />
                  <Partners />
                  <NetworkingTimeline />
                </>
              }
            />
            <Route path="/about" element={<WhoWeAre />} />
            <Route path="/about-igi" element={<AboutIGI />} />
            <Route path="/agenda" element={<Agenda />} />
            <Route path="/speakers" element={<Speakers />} />
            <Route path="/speakers/:id" element={<SpeakerDetails />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/latestnews" element={<LatestNews />} />
            <Route path="/latestnews/:id" element={<LatestNewsDetails />} />
            <Route path="/publications" element={<Publications />} />
            <Route path="/publications/:id" element={<PublicationDetails />} />
            <Route path="/register" element={<RegistrationForm />} />

            {/* Redirect unknown routes to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Participation />
          <Footer />
        </main>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
